import moment from 'moment';
import { memo } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import 'react-datepicker/dist/react-datepicker.css';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import { useSelector } from 'react-redux';
import { checkDoctorDept } from '../../../../utils/helpers';

const Others = ({ selectedHistories, setSelectedHistories }) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const specialties = useSelector(
    (state) => state.specialtyReducer.specialties,
  );
  const defaultData = {
    surgicalHistory: '',
    allergicHistory: '',
    mh: {
      regular: false,
      irregular: false,
      menapause: false,
      pregnancy: false,
      note: '',
    },
    vaccinationDone: '',
    vaccinationDoneNote: '',
    vaccinationDate: null,
    vaccinationDateNote: '',
  };

  const selectedData = selectedHistories?.others || defaultData;

  const handleData = (itemName, fieldName, val) => {
    setSelectedHistories((prev) => ({
      ...prev,
      others: {
        ...prev.others,
        ...(itemName === 'mh'
          ? { mh: { ...prev.others?.mh, [fieldName]: val } }
          : { [itemName]: val }),
      },
    }));
  };

  const renderTextarea = (label, itemName, value) => (
    <Row className="mb-2">
      <Col md={2} className="pt-1">
        {label}:
      </Col>
      <Col>
        <Form.Control
          size="sm"
          as="textarea"
          rows={1}
          placeholder="Add note"
          value={value}
          onChange={(e) => handleData(itemName, '', e.target.value)}
        />
      </Col>
    </Row>
  );

  const mhOptions = [
    { key: 'regular', label: 'Regular' },
    { key: 'irregular', label: 'Irregular' },
    { key: 'menapause', label: 'Menopause' },
    { key: 'pregnancy', label: 'Pregnancy' },
  ];

  const isEndocrinology = checkDoctorDept(
    'endocrinology',
    userInfo?.speciality[0],
    specialties,
  );

  return (
    <div className="surgical-history">
      {!isEndocrinology && (
        <>
          {renderTextarea(
            'Surgical History',
            'surgicalHistory',
            selectedData.surgicalHistory,
          )}
          {renderTextarea(
            'Allergic History',
            'allergicHistory',
            selectedData.allergicHistory,
          )}
        </>
      )}

      <Row>
        <Col md={2}>M/H:</Col>
        <Col md={4}>
          <Row>
            {mhOptions.map((opt) => (
              <Col key={opt.key}>
                <Form.Check
                  type="checkbox"
                  id={opt.key}
                  label={opt.label}
                  checked={!!selectedData.mh?.[opt.key]}
                  onChange={(e) => handleData('mh', opt.key, e.target.checked)}
                />
              </Col>
            ))}
          </Row>
        </Col>
        <Col>
          <Form.Control
            size="sm"
            as="textarea"
            placeholder="Add note"
            value={selectedData.mh?.note}
            onChange={(e) => handleData('mh', 'note', e.target.value)}
          />
        </Col>
      </Row>

      {isEndocrinology && (
        <>
          <div className="title-gyne-examination">Vaccination History:</div>
          <hr className="hr" />
          <Row className="mb-2">
            <Col md={2}>Vaccination Done:</Col>
            <Col md={1}>
              <Form.Check
                type="radio"
                id={'opt.key'}
                label={'Yes'}
                checked={selectedData?.vaccinationDone === 'yes'}
                onChange={(e) => handleData('vaccinationDone', '', 'yes')}
              />
            </Col>
            <Col md={1}>
              <Form.Check
                type="radio"
                id={'opt.key'}
                label={'No'}
                checked={selectedData?.vaccinationDone === 'no'}
                onChange={(e) => handleData('vaccinationDone', '', 'no')}
              />
            </Col>
            <Col md={1}>
              <Button
                size="sm"
                variant="outline-danger"
                className="clr-btn"
                onClick={() => handleData('vaccinationDone', '', '')}
              >
                Clear
              </Button>
            </Col>
            <Col>
              <Form.Control
                size="sm"
                as="textarea"
                rows={1}
                placeholder="Add note"
                value={selectedData?.vaccinationDoneNote}
                onChange={(e) =>
                  handleData('vaccinationDoneNote', '', e.target.value)
                }
              />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={2} className="pt-1">
              Vaccination Date:
            </Col>
            <Col md={3}>
              <DateTimePicker
                onChange={(date) =>
                  handleData(
                    'vaccinationDate',
                    '',
                    date ? moment(date).format('YYYY-MM-DD') : '',
                  )
                }
                value={
                  selectedData?.vaccinationDate
                    ? new Date(selectedData?.vaccinationDate)
                    : null
                }
                disableClock={true} // hides the clock
                format="y-MM-dd" // only show year-month-day
              />
            </Col>
            <Col>
              <Form.Control
                size="sm"
                as="textarea"
                rows={1}
                placeholder="Add note"
                value={selectedData?.vaccinationDateNote}
                onChange={(e) =>
                  handleData('vaccinationDateNote', '', e.target.value)
                }
              />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default memo(Others);
